import { Pipe, PipeTransform } from '@angular/core';

import { AccountSegmentSelection } from '@libs/src/models/account.model';

import find from 'lodash-es/find';

@Pipe({ name: 'getSegmentSelection' })
export class GetSegmentSelectionPipe implements PipeTransform {
  transform(
    selections: AccountSegmentSelection[],
    customSegmentId: string,
  ): AccountSegmentSelection {
    return find(selections, { custom_segment: customSegmentId });
  }
}
